import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ArrowRight } from 'lucide-react'
import { api } from '@/lib/api'
import { formatCurrency } from '@/lib/utils'

export function WritersPage() {
  const { data: writers = [] } = useQuery({ queryKey: ['writers'], queryFn: api.writers })

  return (
    <div className="p-3 md:p-5 max-w-[1400px] mx-auto flex flex-col gap-3.5">
      <header className="flex justify-between items-start">
        <div>
          <h1 className="text-xl font-medium">Writers</h1>
          <p className="text-xs text-ink-secondary mt-0.5">
            Active roster. Head to invoicing for budget burndown.
          </p>
        </div>
        <Link
          to="/invoicing"
          className="text-xs border border-border rounded-md px-2.5 py-1.5 hover:bg-surface-muted flex items-center gap-1.5"
        >
          Invoicing <ArrowRight size={13} />
        </Link>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        {writers.map((w) => (
          <article key={w.id} className="border border-border rounded-md bg-surface-card p-3.5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-full bg-brand-50 text-brand-800 text-sm font-medium flex items-center justify-center">
                {w.avatar_initials}
              </span>
              <div className="min-w-0">
                <div className="font-medium truncate">{w.name}</div>
                <div className="text-[11px] text-ink-tertiary truncate">{w.email}</div>
              </div>
            </div>
            <div className="mt-2.5 text-xs text-ink-secondary">{w.specialty ?? 'Generalist'}</div>
            <div className="mt-2.5 grid grid-cols-2 gap-2 text-xs">
              <div>
                <div className="text-ink-tertiary text-[10px] uppercase tracking-wider">Rate</div>
                <div className="tabular-nums">
                  {formatCurrency(w.rate_cents)}/{w.rate_unit}
                </div>
              </div>
              <div>
                <div className="text-ink-tertiary text-[10px] uppercase tracking-wider">Pieces MTD</div>
                <div className="tabular-nums">{w.pieces_mtd}</div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}
